module.exports = __webpack_public_path__ + "static/media/popular-game3.86336ca4.png";